import { render, staticRenderFns } from "./UnfoldLessHorizontal.vue?vue&type=template&id=53982bc6"
import script from "./UnfoldLessHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldLessHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports